import { useEffect } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router";
import { Logo } from "@shared/components/Logo.tsx";
import { MAIN_SITE_URL } from "@shared/config.ts";
import { COMPETITION } from "./content/competition.ts";

const M = MAIN_SITE_URL;

/** Competition nav — sits in the same red bar the main site uses. */
const TABS = [
  { to: "/", label: "मुखपृष्ठ", end: true },
  { to: "/rules", label: "माहिती, नियम आणि अटी" },
  { to: "/register", label: "नोंदणी" },
  { to: "/find-id", label: "आयडी शोधा" },
  { to: "/about", label: "संपर्क" },
];

export function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    globalThis.scrollTo({ top: 0 });
  }, [pathname]);

  return (
    <div className="site">
      {/* ============ HEADER (matches chatrapatisevapratishthan.org) ============ */}
      <header className="site-header">
        <div className="site-header__top container">
          <a
            href={M}
            className="site-header__brand"
            aria-label="छत्रपती सेवा प्रतिष्ठान, नागपूर-पुणे — मुख्य संकेतस्थळ"
          >
            <Logo size={72} className="site-logo" />
            <span className="site-header__title">
              छत्रपती सेवा प्रतिष्ठान, नागपूर-पुणे
            </span>
          </a>
        </div>
        <nav className="site-nav" aria-label="स्पर्धा मेनू">
          <div className="container site-nav__inner">
            <ul className="site-nav__list">
              {TABS.map((t) => (
                <li key={t.to}>
                  <NavLink
                    to={t.to}
                    end={t.end}
                    className={({ isActive }) => (isActive ? "is-active" : "")}
                  >
                    {t.label}
                  </NavLink>
                </li>
              ))}
            </ul>
            <a className="site-nav__back" href={M}>
              ← मुख्य संकेतस्थळ
            </a>
          </div>
        </nav>
      </header>

      <main className="site-main" id="main">
        <Outlet />
      </main>

      {/* ============ FOOTER (matches chatrapatisevapratishthan.org) ============ */}
      <footer className="site-footer">
        <div className="container">
          <div className="site-footer__grid">
            <div>
              <Logo size={60} className="site-footer__logo" />
              <h4>छत्रपती सेवा प्रतिष्ठान, नागपूर-पुणे</h4>
              <p className="site-footer__tag">
                {COMPETITION.name} {COMPETITION.season}
              </p>
            </div>
            <div>
              <h4>स्पर्धा</h4>
              <ul>
                <li>
                  <Link to="/rules">माहिती, नियम आणि अटी</Link>
                </li>
                <li>
                  <Link to="/register">नोंदणी</Link>
                </li>
                <li>
                  <Link to="/find-id">आयडी शोधा</Link>
                </li>
                <li>
                  <Link to="/about">संपर्क</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>संस्था</h4>
              <ul>
                <li>
                  <a href={M}>मुखपृष्ठ</a>
                </li>
                <li>
                  <a href={`${M}about-us/`}>आमच्याविषयी</a>
                </li>
                <li>
                  <a href={`${M}shivkathakar-vijayrao-deshmukh/`}>
                    प्रेरणास्थान
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4>ग्रंथलेखन</h4>
              <ul>
                <li>
                  <a href={`${M}shakkarte-shivraya/`}>शककर्ते शिवराय</a>
                </li>
                <li>
                  <a href={`${M}raja-shambhuchatrapati/`}>राजा शंभुछत्रपती</a>
                </li>
                <li>
                  <a href={`${M}literature/`}>इतर ग्रंथलेखन</a>
                </li>
              </ul>
            </div>
            <div>
              <h4>उपक्रम</h4>
              <ul>
                <li>
                  <a href={`${M}jeejamata-vidvatgaurav-puraskar/`}>
                    जिजामाता विद्वतगौरव पुरस्कार
                  </a>
                </li>
                <li>
                  <a href={`${M}lectures/`}>व्याख्यानमाला</a>
                </li>
                <li>
                  <a href={`${M}visit-to-forts/`}>किल्लेदर्शन यात्रा</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="site-footer__bottom">
            Copyright 2026. All rights Reserved
          </div>
        </div>
      </footer>
    </div>
  );
}

/** Orange title banner with the dotted rule — same as the main site's page banners. */
export function PageBanner({ title, sub }: { title: string; sub?: string }) {
  return (
    <div className="page-banner">
      <div className="container page-banner__inner">
        <h1>{title}</h1>
        <span className="page-banner__dots" aria-hidden="true" />
      </div>
      {sub && <p className="container page-banner__sub">{sub}</p>}
    </div>
  );
}
